import { LucideProps } from "lucide-react";
import { ForwardRefExoticComponent, RefAttributes } from "react";
import { NavigationItem } from "./NavigationItem";
import { SheetClose } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

interface Item {
  icon: ForwardRefExoticComponent<
    Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>
  >;
  url: string;
  title: string;
}

interface ItemsProps {
  items: Item[];
  className?: string;
}

export const MobileNavigationItems = ({ items, className }: ItemsProps) => (
  <menu className={cn("flex flex-col gap-3 my-2", className)}>
    {items.map((item, index) => (
      <li key={`${item.url}-${index}`}>
        <SheetClose asChild>
          <NavigationItem
            item={item}
            className="flex gap-1 items-center"
            iconClassName="!size-4"
          />
        </SheetClose>
      </li>
    ))}
  </menu>
);
